// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoice-notice-dialog .el-dialog__header{border-bottom:1px solid #d2d2d2;height:63px;text-align:center}.invoice-notice-dialog .el-dialog__body{padding:41px 54px 36px 50px}.invoice-notice-dialog .invoice-notice-btn{width:220px;height:32px;background:#ca4300;border-radius:3px;line-height:1;padding:0;color:#fff;margin:auto;display:block}", ""]);
// Exports
module.exports = exports;
